// "Set up your training" (empty program): the same plan chooser as Settings, so a new
// plan is always the book's exact routine or the glute plan, reviewed before it saves.
import { openPlanChooser } from './plan-chooser.js';

export function openProgramSetup(onDone) {
  openPlanChooser({ onApplied: onDone });
}
